import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "../cn";
export const ErrorContainer = ({ children, className }) => {
    return (_jsx("div", { "data-testid": "error-container", className: cn("grid gap-8", className), children: children }));
};
